// Source: https://github.com/ipatate/react-router-scroll-memory/blob/master/src/utils/utils.js

/**
 * get the scroll of page
 * @return {number}
 */
export const getScrollPage = (): number => {
    let docScrollTop = 0;
    if (document.documentElement && document.documentElement !== null) {
        docScrollTop = document.documentElement.scrollTop;
    }
    return window.pageYOffset || docScrollTop;
};

/**
 * get the scroll of a parent element
 * @return {number}
 */
export const getScrollElement = (elementSelector: string): number => {
    let elemScrollTop = 0;
    const element = document.querySelector(elementSelector);
    if (element !== null) {
        elemScrollTop = element.scrollTop;
    }
    return elemScrollTop;
};

/**
 * scroll to y number of a page
 * @param {number} scrollnumber
 * @return {void}
 */
export const scrollTo = (scrollnumber: number = 0): number =>
    window.requestAnimationFrame(() => {
        window.scrollTo(0, scrollnumber);
    });

/**
 * scroll to y number inside an element
 * @param {number} scrollnumber
 * @return {void}
 */
export const scrollToElement = (scrollnumber: number = 0, element: HTMLElement | null): void => {
    if (element) {
        element.scrollTop = scrollnumber;
    }
};

/**
 * verif if window exist
 * @return boolean
 */
export const isBrowser = (): boolean => typeof window !== "undefined";
